module.exports = __webpack_public_path__ + "img/banner2a.5654c524.jpg";